/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiMonitoringAlert } from './InternalApiMonitoringAlert';
import {
    InternalApiMonitoringAlertFromJSON,
    InternalApiMonitoringAlertFromJSONTyped,
    InternalApiMonitoringAlertToJSON,
    InternalApiMonitoringAlertToJSONTyped,
} from './InternalApiMonitoringAlert';

/**
 * 
 * @export
 * @interface InternalApiAlertsPage
 */
export interface InternalApiAlertsPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertsPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiMonitoringAlert>}
     * @memberof InternalApiAlertsPage
     */
    content: Array<InternalApiMonitoringAlert>;
}

/**
 * Check if a given object implements the InternalApiAlertsPage interface.
 */
export function instanceOfInternalApiAlertsPage(value: object): value is InternalApiAlertsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiAlertsPageFromJSON(json: any): InternalApiAlertsPage {
    return InternalApiAlertsPageFromJSONTyped(json, false);
}

export function InternalApiAlertsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiMonitoringAlertFromJSON)),
    };
}

export function InternalApiAlertsPageToJSON(json: any): InternalApiAlertsPage {
    return InternalApiAlertsPageToJSONTyped(json, false);
}

export function InternalApiAlertsPageToJSONTyped(value?: InternalApiAlertsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiMonitoringAlertToJSON)),
    };
}

